import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Slide, TextField, Typography } from '@mui/material';
import { TransitionProps } from '@mui/material/transitions';
import React, { forwardRef } from 'react'
import { theme } from '../../../../../theme';
import { emailTemplate, toTitleCase } from '../../../CandidateManagement/CandidateContent/CandidateContent';
import CloseIcon from '@mui/icons-material/Close';
import ReactQuill from 'react-quill';

const Transition = forwardRef((
    props: TransitionProps & { children: React.ReactElement<any, any>; },
    ref: React.Ref<unknown>
) => {
    return <Slide direction="left" ref={ref} {...props} />;
});

interface ReUploadNotifyProps {
    isOpen: boolean;
    onClose: () => void;
    candidateName: string;
    candidateEmail: string;
    emailBody: string;
    emailSubject: string;
    setEmailSubject: (value: string) => void;
    setEmailBody: (value: string) => void;
    handleSendEmailNotification: () => void;
}

const ReUploadNotify: React.FC<ReUploadNotifyProps> = ({ isOpen, onClose, candidateName, candidateEmail, emailBody, emailSubject, setEmailSubject, setEmailBody, handleSendEmailNotification }) => {
    return (
        <Dialog
            open={isOpen}
            onClose={() => { }}
            TransitionComponent={Transition}
            fullScreen
            BackdropProps={{ style: { backgroundColor: 'transparent' } }}
            PaperProps={{
                sx: {
                    maxWidth: '22vw',
                    height: '100vh',
                    margin: 0,
                    overflow: 'hidden',
                    position: 'absolute',
                    right: 0,
                },
            }}
        >
            <DialogTitle sx={{ display: 'flex', p: '2vh 1.5vw 0px 1vw' }}>
                {/* <Box
                    color={theme.palette.secondary.main}
                    sx={{
                        border: '1px solid #EEEEEE',
                        bgcolor: theme.palette.secondary.light,
                        margin: '0.3vw',
                        mr: '1vw',
                        width: '3vw',
                        height: '3vw',
                        borderRadius: '1vw',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                >
                    <i className="fa-regular fa-bell"></i>
                </Box> */}
                <Box sx={{ flexGrow: 1 }}>
                    <Typography variant="h6">Request Document Re-Upload</Typography>
                    <Typography variant="caption">{toTitleCase(candidateName || '')}</Typography>
                </Box>
                <IconButton
                    edge="end"
                    color="inherit"
                    sx={{ position: 'relative', width: '2vw', height: '4vh' }}
                    onClick={onClose}
                    aria-label="close"
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent dividers>
                {/* Communication Medium */}
                <TextField
                    label="Email"
                    size="small"
                    value={candidateEmail}
                    fullWidth
                    margin="dense"
                    required
                    InputProps={{
                        readOnly: true,
                    }}
                />


                {/* Subject */}
                <TextField
                    label="Subject"
                    size="small"
                    value={emailSubject}
                    onChange={(e) => setEmailSubject(e.target.value)}
                    fullWidth
                    sx={{ marginY: '2vh' }}
                    required
                    autoComplete='off'
                    error={!emailSubject}
                    helperText={!emailSubject ? 'Subject is required' : ''}
                />

                {/* Message */}
                <ReactQuill
                    value={emailBody}
                    onChange={setEmailBody}
                    style={{ height: '28vh', marginTop: '1vh' }}
                    modules={{
                        toolbar: [['bold', 'italic', 'link', { list: 'ordered' }, { list: 'bullet' }]],
                    }}
                // readOnly={!status}
                />
            </DialogContent>
            <DialogActions >
                <Button variant="contained" color="primary" fullWidth
                    onClick={handleSendEmailNotification}
                >
                    Send
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default ReUploadNotify